import { render, staticRenderFns } from "./app-wrapper.vue?vue&type=template&id=f6d1d9be"
import script from "./app-wrapper.vue?vue&type=script&lang=js"
export * from "./app-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports